import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SpinnerOverlayService {
  private spinnerStateSubject = new Subject<ISpinnerState>();
  spinnerState = this.spinnerStateSubject.asObservable();

  constructor() {}

  show(): void {
    this.spinnerStateSubject.next(<ISpinnerState>{ visible: true });
  }

  hide(): void {
    this.spinnerStateSubject.next(<ISpinnerState>{ visible: false });
  }
}

export interface ISpinnerState {
  visible: boolean;
}
